import { newTherapyTemplateAction } from 'src/redux/actions/constant';

const {
  EDIT_THERAPY_TEMPLATE_SUCCESS,
  EDIT_THERAPY_TEMPLATE_FAILURE,
  EDIT_THERAPY_TEMPLATE_LOADING,
  EDIT_THERAPY_TEMPLATE_RESET,
} = newTherapyTemplateAction;

const initialstate: object = {
  response: null,
  loading: false,
};

export const editTherapyTemplateReducer = (state = initialstate, action: any) => {
  switch (action.type) {
    case EDIT_THERAPY_TEMPLATE_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
      };
    }

    case EDIT_THERAPY_TEMPLATE_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
      };

    case EDIT_THERAPY_TEMPLATE_LOADING:
      return {
        ...state,
        loading: true,
      };

    case EDIT_THERAPY_TEMPLATE_RESET:
      return initialstate;

    default:
      return state;
  }
};
